/**
 * Pure routing of follow-up / CRM-lead push payloads (no network or React imports, so the notification
 * navigation helper and its Jest tests can use it freely).
 * @module helpers/followUpTarget
 */

/**
 * Route target of a push / deep link about follow-ups or leads.
 * @param {object} data push `data` / inbox metadata ({eventKey, followUpId, leadId, customerId, url}).
 * @returns {{kind: 'followUps'|'lead'|'customer', params: object}|null} target or null when unrelated.
 */
export const resolveFollowUpTarget = (data) => {
    const d = data && typeof data === 'object' ? data : {};
    const eventKey = String(d.eventKey || d.eventkey || '').toLowerCase();
    const get = (...keys) => {
        for (const k of keys) {
            if (d[k] !== undefined && d[k] !== null && String(d[k]).trim() !== '') {
                return String(d[k]).trim();
            }
        }

        return '';
    };

    if (eventKey.startsWith('crm.followup.')) {
        const focus = get('followUpId', 'followupid');
        const calendarEventId = get('calendarEventId', 'calendareventid');
        const single = !eventKey.includes('digest');

        // Digests and "missing" nudges are lists; single events focus one row. A push that only carries the
        // linked calendar event (no follow-up id, no lead) still lands on the to-do — the screen maps it to the row.
        if (single && focus) {
            return {kind: 'followUps', params: {focus}};
        }

        return {kind: 'followUps', params: single && calendarEventId ? {calendarEventId} : {}};
    }

    if (eventKey.startsWith('crm.lead.')) {
        const leadId = get('leadId', 'leadid');

        return leadId ? {kind: 'lead', params: {type: 'leads', id: leadId}} : {kind: 'followUps', params: {}};
    }

    return null;
};
